// import library
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import component
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { env } from "../../env";
import axios from "axios";
import LoaderIcon from "../../components/Common/Icon/Loader";
import Layout from "../../layouts/Layout";
import { AuthContext } from "../../context";
import WarningPopUp from "../../components/Profile/WarningPopUp";

const TaskTemplateIndex = () => {
    // variables
    const { t } = useTranslation();
    const { customerId } = useParams();
    const authContext = useContext(AuthContext);
    const navigate = useNavigate();
    const storedVisitData = localStorage.getItem('visit');
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [isLoader, setIsLoader] = useState(true);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    const [taskTemplateList, setTaskTemplateList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            await getTaskTemplateListApi(baseUrl, token);
        };
        fetchData();
    }, [baseUrl, token]);

    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    // api's
    const getTaskTemplateListApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Task/QuickTaskTemplateList`,{ headers })
        .then((response) => {
            setTaskTemplateList(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            setIsLoader(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    // functions
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };

    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="flex justify-between items-center">
                    <div className="w-44 sm:w-auto">
                        <h1 className="text-sm sm:text-2xl font-semibold capitalize">{ t('task templates') }</h1>
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center cursor-pointer"><NavLink to={`/profiles/task/${customerId}`}>{ t('task list') }</NavLink> /{ t('task templates') }</div>
                    </div>
                    <div className="hidden sm:block">
                        <NavLink to={`/profiles/detail/${customerId}`}>
                            <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                            </div>
                        </NavLink>
                    </div>
                </div>
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                    <div className={(taskTemplateList.length > 0 ? "grid lg:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-4" : "") + " bg-white sm:bg-transparent rounded-xl sm:rounded-none p-2 sm:p-0"}>
                        {(taskTemplateList.length > 0) ?
                            taskTemplateList.map((template, index) => (
                                <div key={`template${index}`}>
                                    <NavLink to={`/profiles/create-task/${template.id}/${customerId}`} className="">
                                        <div className="flex space-x-2 items-center sm:rounded-xl sm:bg-white sm:p-3 w-full">
                                            <div className="bg-blue-light rounded-xl p-2">
                                                <img className="w-6 h-6 sm:w-8 sm:h-8" src="../../assets/icons/profile/file.svg" alt="file" />
                                            </div>
                                            <div className="space-y-0.5 w-full">
                                                <div className="flex justify-between items-center">
                                                    <h1 className="font-semibold text-xs sm:text-base capitalize">{template.description}</h1>
                                                    <img src="../../assets/icons/profile/arrow-right.svg" alt="arrow-right" />
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="first-letter:capitalize text-[10px] sm:text-xs">
                                                    {template.fromDate} - {template.toDate}
                                                    </div>
                                                    <div className="bg-green-normal text-white text-[10px] sm:text-xs py-0.5 px-1 capitalize rounded-md">
                                                        normal
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    {(taskTemplateList.length !== (index+1)) ? <div className="my-1 border-t border-dashed border-background-normal block sm:hidden"></div> : null}
                                </div>
                            ))
                        :
                            <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white">
                                { t('no data available')}
                            </div>
                        }
                    </div>
                }
            </Layout>
            {/* common */}
            {showWarningPopUp && <WarningPopUp customerId={customerId} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default TaskTemplateIndex;